export default __webpack_public_path__ + "static/media/flag.0c0e0b8d.svg";